import { Button } from '@/components/ui'
import { appConfig } from '@/types/env'
import { GoogleIcon, GitHubIcon } from '@/components/icons/OAuthIcons'

// Get OAuth base URL (must be absolute URL to backend domain)
// Remove /api suffix since OAuth endpoints are at root level
function getOAuthBaseURL() {
  let url = appConfig.API_URL

  // Ensure it's an absolute URL
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    // Relative URL - convert to absolute
    url = window.location.protocol + '//' + url
  }

  // Remove /api suffix
  if (url.endsWith('/api')) {
    url = url.slice(0, -4)
  }

  return url
}

const OAUTH_BASE_URL = getOAuthBaseURL()

export function OAuthButtons() {
  const handleGoogleLogin = () => {
    window.location.href = `${OAUTH_BASE_URL}/accounts/google/login/`
  }

  const handleGithubLogin = () => {
    window.location.href = `${OAUTH_BASE_URL}/accounts/github/login/`
  }

  return (
    <div className="space-y-3">
      {/* Google OAuth Button */}
      <Button
        type="button"
        variant="outline"
        className="group relative w-full overflow-hidden"
        onClick={handleGoogleLogin}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-blue-600/10 opacity-0 transition-opacity group-hover:opacity-100" />
        <GoogleIcon className="relative z-10 mr-2 h-5 w-5" />
        <span className="relative z-10">Continue with Google</span>
      </Button>

      {/* GitHub OAuth Button */}
      <Button
        type="button"
        variant="outline"
        className="group relative w-full overflow-hidden"
        onClick={handleGithubLogin}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-foreground/5 to-foreground/10 opacity-0 transition-opacity group-hover:opacity-100" />
        <GitHubIcon className="relative z-10 mr-2 h-5 w-5" />
        <span className="relative z-10">Continue with GitHub</span>
      </Button>
    </div>
  )
}
